// states.js
export const states = [
  { value: "ALABAMA", label: "AL - ALABAMA" },
  { value: "ALASKA", label: "AK - ALASKA" },
  { value: "ARIZONA", label: "AZ - ARIZONA" },
  { value: "ARKANSAS", label: "AR - ARKANSAS" },
  { value: "CALIFORNIA", label: "CA - CALIFORNIA" },
  { value: "COLORADO", label: "CO - COLORADO" },
  { value: "CONNECTICUT", label: "CT - CONNECTICUT" },
  { value: "DELAWARE", label: "DE - DELAWARE" },
  { value: "District of Columbia", label: "DC - District of Columbia" },
  { value: "FLORIDA", label: "FL - FLORIDA" },
  { value: "GEORGIA", label: "GA - GEORGIA" },
  { value: "HAWAII", label: "HI - HAWAII" },
  { value: "IDAHO", label: "ID - IDAHO" },
  { value: "ILLINOIS", label: "IL - ILLINOIS" },
  { value: "INDIANA", label: "IN - INDIANA" },
  { value: "IOWA", label: "IA - IOWA" },
  { value: "KANSAS", label: "KS - KANSAS" },
  { value: "KENTUCKY", label: "KY - KENTUCKY" },
  { value: "LOUISIANA", label: "LA - LOUISIANA" },
  { value: "MAINE", label: "ME - MAINE" },
  { value: "MARYLAND", label: "MD - MARYLAND" },
  { value: "MASSACHUSETTS", label: "MA - MASSACHUSETTS" },
  { value: "MICHIGAN", label: "MI - MICHIGAN" },
  { value: "MINNESOTA", label: "MN - MINNESOTA" },
  { value: "MISSISSIPPI", label: "MS - MISSISSIPPI" },
  { value: "MISSOURI", label: "MO - MISSOURI" },
  { value: "MONTANA", label: "MT - MONTANA" },
  { value: "NEBRASKA", label: "NE - NEBRASKA" },
  { value: "NEVADA", label: "NV - NEVADA" },
  { value: "NEW HAMPSHIRE", label: "NH - NEW HAMPSHIRE" },
  { value: "NEW JERSEY", label: "NJ - NEW JERSEY" },
  { value: "NEW MEXICO", label: "NM - NEW MEXICO" },
  { value: "NEW YORK", label: "NY - NEW YORK" },
  { value: "NORTH CAROLINA", label: "NC - NORTH CAROLINA" },
  { value: "NORTH DAKOTA", label: "ND - NORTH DAKOTA" },
  { value: "OHIO", label: "OH - OHIO" },
  { value: "OKLAHOMA", label: "OK - OKLAHOMA" },
  { value: "OREGON", label: "OR - OREGON" },
  { value: "PENNSYLVANIA", label: "PA - PENNSYLVANIA" },
  { value: "RHODE ISLAND", label: "RI - RHODE ISLAND" },
  { value: "SOUTH CAROLINA", label: "SC - SOUTH CAROLINA" },
  { value: "SOUTH DAKOTA", label: "SD - SOUTH DAKOTA" },
  { value: "TENNESSEE", label: "TN - TENNESSEE" },
  { value: "TEXAS", label: "TX - TEXAS" },
  { value: "UTAH", label: "UT - UTAH" },
  { value: "VERMONT", label: "VT - VERMONT" },
  { value: "VIRGINIA", label: "VA - VIRGINIA" },
  { value: "WASHINGTON", label: "WA - WASHINGTON" },
  { value: "WEST VIRGINIA", label: "WV - WEST VIRGINIA" },
  { value: "WISCONSIN", label: "WI - WISCONSIN" },
  { value: "WYOMING", label: "WY - WYOMING" },
];
